import { render, staticRenderFns } from "./UiSelectChecklist.vue?vue&type=template&id=4d138c67&"
import script from "./UiSelectChecklist.vue?vue&type=script&lang=js&"
export * from "./UiSelectChecklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports